// Official post-event figures — client-confirmed fixed copy (do not derive from live data).
export const METRICS = {
  attendees: "125",
  primes: "13",
  formal: "67",
  sbePrime: "49",
  tlPrime: "18",
};

export const COMMUNITY_PARTNERS = [
  { name: "Universal Destinations & Experiences", logo: "/logos/universal.png" },
  { name: "Orlando Health", logo: "/logos/orlando-health.png" },
  { name: "Orange County Government", logo: "/logos/orange-county.png" },
  { name: "City of Orlando", logo: "/logos/city-of-orlando.png" },
  { name: "Florida Business Development Council", logo: "/logos/fbdc.png" },
  { name: "Central Florida Expressway Authority", logo: "/logos/cfx.png" },
  { name: "Hispanic Chamber of Metro Orlando", logo: "/logos/hcmo.png" },
  { name: "NMSDC", logo: "/logos/nmsdc.png" },
  { name: "Business Consortium Fund", logo: "/logos/bcf.png" },
];

// Records that are NOT participating Prime Suppliers (substring match, lowercased).
export const PRIME_EXCLUDE = ["hd supply", "display america event services", "orange county"];

// Recognition groups (distinct categories preserved).
export const RECOGNITION_GROUPS = [
  { key: "primes", label: "Prime Suppliers", note: "Strategic suppliers who presented at the Supplier Showcase and Business Matchmaking." },
  { key: "community", label: "Community Partners", note: "Regional leaders supporting supplier development." },
  { key: "tl_team", label: "Travel + Leisure Sourcing Team", note: "Executives and sourcing professionals." },
  { key: "sbe", label: "Small Business Enterprises", note: "Qualified SBEs engaged through matchmaking." },
  { key: "speakers", label: "Speakers", note: "Session and panel contributors." },
  { key: "guests", label: "Summit Guests", note: "Invited partners and observers." },
];

export const IMG = "/highlights";

// Editorial photo story — ordered per the case-study narrative.
export const PHOTO_STORY = [
  { src: `${IMG}/registration.webp`, theme: "Welcome & Registration", caption: "Check-in on the Travel + Leisure floor" },
  { src: `${IMG}/welcome-crowd.webp`, theme: "Executive & Educational Sessions", caption: "Travel + Leisure Executive Welcome" },
  { src: `${IMG}/session-audience.webp`, theme: "Executive & Educational Sessions", caption: "A full audience for the opening session" },
  { src: `${IMG}/portrait-a.webp`, theme: "Executive & Educational Sessions", caption: "Executive panel on second-tier opportunity" },
  { src: `${IMG}/showcase-people-1.webp`, theme: "Supplier Showcase", caption: "Supplier Showcase — Heartbeat 3 & 4" },
  { src: `${IMG}/showcase-people-2.webp`, theme: "Supplier Showcase", caption: "Conversations at the Prime Supplier stations" },
  { src: `${IMG}/showcase-floor.webp`, theme: "Supplier Showcase", caption: "The Showcase floor in full swing" },
  { src: `${IMG}/showcase-empty.webp`, theme: "Supplier Showcase", caption: "Branded Prime Supplier showcase stations" },
  { src: `${IMG}/matchmaking-2.webp`, theme: "Business Matchmaking", caption: "Business Matchmaking — Heartbeat 1 & 2" },
  { src: `${IMG}/matchmaking-1.webp`, theme: "Business Matchmaking", caption: "67 formal meetings designed to create meaningful business connections" },
  { src: `${IMG}/portrait-b.webp`, theme: "Networking & Engagement", caption: "125 attendees connected across the supplier ecosystem" },
  { src: `${IMG}/portrait-c.webp`, theme: "Networking & Engagement", caption: "Relationship-building across the ecosystem" },
  { src: `${IMG}/room-setup.webp`, theme: "Event Environment", caption: "The Summit floor, prepared for the day" },
  { src: `${IMG}/aerial-2.webp`, theme: "Event Environment", caption: "Travel + Leisure, Orlando" },
];
